import {$swoole} from './axios.setup'

// getInspectionReport
// - 2023.06.20
export const getInspectionReport = async ({params}) => {
  const url = '/v1/vehicleInspection/report'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getInspectionReportFlaw
// - 2023.06.21
export const getInspectionReportFlaw = async ({params}) => {
  const url = '/v1/vehicleInspection/flaw'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getInspectReportMileage
// - 2023.06.27
export const getInspectReportMileage = async ({params}) => {
  const url = '/v1/vehicleInspection/mileage'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getReportInspection
// - 2024.04.02
export const getReportInspection = async ({params}) => {
  const url = '/v1/vehicleInspection/appraise'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getReportInspectionFields
// - 2024.12.19
// - Get report inspection fields
export const getReportInspectionFields = async ({params}) => {
  const url = '/v1/vehicleInspection/appraise/checkPoints'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getReportInspectionFieldDetail
// - 2024.12.19
// - Get report inspection field detail
export const getReportInspectionField = async ({params}) => {
  const url = '/v1/vehicleInspection/appraise/checkPointItem'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}

// getReportInspectionPreview
// - 2025.05.16
// - Get report inspection preview
export const getReportInspectionPreview = async ({params}) => {
  const url = '/v1/vehicleInspection/appraise/forestall'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}
